module.exports = __webpack_public_path__ + "img/bg-4.37340b69.jpg";